import { fork } from 'redux-saga/effects';

import { saga as authSaga } from './reducers/Auth';
import { saga as navigationSaga } from './reducers/Navigation';
import { saga as taskSaga } from './reducers/Task';
import { saga as clientSaga } from './reducers/Client';
import { saga as companySaga } from './reducers/Company';
import { saga as performanceCommentSaga } from './reducers/PerformanceComment';
import { saga as projectSaga } from './reducers/Project';
import { saga as projectStaffingSaga } from './reducers/ProjectStaffing';
import { saga as landmanSaga } from './reducers/Landman';
import { saga as userSaga } from './reducers/User';
import { saga as officeSaga } from './reducers/Office';
import { saga as profileSaga } from './reducers/Profile';
import { saga as stateSaga } from './reducers/State';
import { saga as tractSaga } from './reducers/Tract';
import { saga as searchSaga } from './reducers/Search';
import { saga as ownerSaga } from './reducers/Owner';
import { saga as phoneNumberTypeSaga } from './reducers/PhoneNumberType';
import { saga as countySaga } from './reducers/County';
import { saga as leaseholdSaga } from './reducers/Leasehold';
import { saga as fileManagementSaga } from './reducers/FileManagement';
import { saga as layoutSaga } from './reducers/Layout';
import { saga as clauseSaga } from './reducers/Clause';
import { saga as leaseGenerationSaga } from './reducers/LeaseGeneration';
import { saga as feedbackSaga } from './reducers/Feedback';
import { saga as ownershipContactCategoriesSaga } from './reducers/OwnershipContactCategories';
import { saga as documentTemplatesSaga } from './reducers/DocumentTemplates';
import { saga as tagsSaga } from './reducers/Tag';
import { saga as cloneSaga } from './reducers/Clone';
import { saga as invoiceSaga } from './reducers/Invoice';

export default function* rootSaga() {
    yield fork(authSaga);
    yield fork(navigationSaga);
    yield fork(taskSaga);
    yield fork(companySaga);
    yield fork(performanceCommentSaga);
    yield fork(projectSaga);
    yield fork(projectStaffingSaga);
    yield fork(landmanSaga);
    yield fork(userSaga);
    yield fork(officeSaga);
    yield fork(clientSaga);
    yield fork(profileSaga);
    yield fork(stateSaga);
    yield fork(tractSaga);
    yield fork(searchSaga);
    yield fork(ownerSaga);
    yield fork(phoneNumberTypeSaga);
    yield fork(countySaga);
    yield fork(leaseholdSaga);
    yield fork(fileManagementSaga);
    yield fork(layoutSaga);
    yield fork(clauseSaga);
    yield fork(leaseGenerationSaga);
    yield fork(feedbackSaga);
    yield fork(ownershipContactCategoriesSaga);
    yield fork(documentTemplatesSaga);
    yield fork(tagsSaga);
    yield fork(cloneSaga);
    yield fork(invoiceSaga);
}



// WEBPACK FOOTER //
// ./src/saga.ts